import { render, staticRenderFns } from "./LogoRestrictedVersionSection.vue?vue&type=template&id=7941dd92"
import script from "./LogoRestrictedVersionSection.vue?vue&type=script&lang=ts"
export * from "./LogoRestrictedVersionSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoRestrictedVersionSection.vue?vue&type=style&index=0&id=7941dd92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports